/*
 * @Author: changcheng
 * @LastEditTime: 2022-09-21 09:53:10
 */
import { Select, Input, Button, Form, Row, Col } from "antd";
import { chinaProvinceData } from "@root/common/data/chinaProvinceData";
const { Option } = Select;
const UserManagement = () => {
  return (
    <div>
      <div>
        <Form>
          <Row>
            <Col span={6}>
              <Form.Item label="省份">
                <Select>
                  <Option value="">全部</Option>
                  {chinaProvinceData.map((item, index) => (
                    <Option val={item.value} key={index}>
                      {item.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item label="姓名">
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="工作单位">
                <Select>
                  <Option value="">全部</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="职称">
                <Select>
                  <Option value="">全部</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="学科">
                <Select>
                  <Option value="">全部</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item>
                <Button type="primary">查询</Button>
                <Button>重置</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
};

export default UserManagement;
